<template>
  <span class="trash-icon-hoverable" @click="showModal = true">
    <i></i>
    <delete-section-modal
      :section-id="sectionId"
      :tasks-count="tasksCount"
      v-if="showModal"
      v-model="showModal"
      @deleted="$emit('deleted')"
    />
  </span>
</template>

<script>
import DeleteSectionModal from '@/components/project/DeleteSectionModal.vue'

/**
 * This provides a trash icon. Click of icon open a modal to delete section.
 */
export default {
  name: 'DeleteSectionIcon',
  props: ['sectionId', 'tasksCount'],
  components: { DeleteSectionModal },
  data() {
    return {
      showModal: false
    }
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
